module.exports = __webpack_public_path__ + "static/media/mmume_11.c76e6fdd.png";